import type OrderPosition               from '@/domains/Orders/OrderPosition';
import Title_ru_RU                      from '@/core/misc/decorators/Title_ru_RU';
import Title_ru_RU_Class                from "@/core/misc/decorators/Title_ru_RU_Class";
import TYPES                            from '@/core/services/Changelogs/types';
import Core                             from "@/core/Core";
import AbstractDocumentPosition         from "@/domains/Abstract/AbstractDocumentPosition";
import ShipmentPosition                 from "@/domains/Shipments/ShipmentPosition";
import Qty                              from "@/core/types/Qty";

@Title_ru_RU_Class('Позиция сборочного листа')      // assemblyPosition → AssemblyPosition
class AssemblyPosition extends AbstractDocumentPosition {

    public isShipped: boolean;
    public isShippedEntirely: boolean;

    /** Реквизит отвечает за то, будет ли закрыт orderPosition после сборки */
    @Title_ru_RU('Метка будет ли закрыта позиция после сборки', TYPES.CUSTOM_BOOLEAN)
    public isOrderNeededToBeClosed: boolean = false;

    @Title_ru_RU('Отгруженное количество', TYPES.NUMBER)
    public qtyShipped: Qty;

    /**  Связь с отгрузкой - приходит с бэка как объект с вложенным shipment */
    public shipmentPosition: ShipmentPosition | null;

	public static fromServer(data: any, result: AssemblyPosition = new AssemblyPosition()): AssemblyPosition {
        super.fromServer(data, result);

        result.qtyShipped = Core.utils.hydrate(data.qtyShipped, Qty.fromServer)!;
        result.shipmentPosition = Core.utils.hydrate(data.shipmentPosition, ShipmentPosition.fromServer);

        return result;
    }

    public static fromOrderPosition(orderPosition: OrderPosition, result: AssemblyPosition = new AssemblyPosition()): AssemblyPosition {
        super.fromOrderPosition(orderPosition, result);

        result.isShipped = false;
        result.isShippedEntirely = false;

        return result;
    }

	public closeOrderPosition(): void {
        this.isOrderNeededToBeClosed = true;
    }

    // Переопределяю полностью метод родителя. Тут добавляется qtyShipped как минимальное значение
    validatePositionQty(value: Qty, availableQty: Qty): string | null {
        /** Собрать разрешено с запасом на пересорт, но не более чем вдвое от
         *  доступного количества. Удвоение намеренное, не опечатка. */
        const maxQty = availableQty.plus(availableQty);

        let minQty: Qty | undefined;

        if (this.qtyShipped) {
            minQty = this.qtyShipped;
        }

        return Core.utils.number.validateDesiredQty(
            value,
            this.orderPosition.packageVolume,
            maxQty,
            minQty,
            this.orderPosition.unit,
        );
    }
}

export default AssemblyPosition;